import { FunctionComponent } from 'react';
import Trans from 'next-translate/Trans';
import { useAppContext } from '../../../../providers/app-context';

const SEOContent: FunctionComponent<{
  withCarInfo: boolean;
  stock: string;
  vehicle: any;
  category: string;
}> = ({ withCarInfo, stock, vehicle, category }) => {
  const { businessValues } = useAppContext();
  return (
    <>
      <div className="lg:text-left text-[14px] leading-[24px] max-lg:text-base">
        <div className="container mx-auto px-4 pt-4 flex flex-col gap-2 text-justify">
          {withCarInfo ? (
            <>
              <Trans
                i18nKey={'sub-categories:seo-content.with-car-info'}
                components={{ p: <p /> }}
                values={{
                  brand: vehicle?.brand.name || '',
                  vehicle: `${vehicle?.brand.name || ''} ${
                    vehicle?.model?.name || ''
                  } ${vehicle?.version?.name || ''}`,
                  count: stock,
                  category: category,
                  totalStockAvailable:
                    businessValues.totalStockAvailable.defaultValue,
                }}
              />
            </>
          ) : (
            <>
              <Trans
                i18nKey={'sub-categories:seo-content.no-info'}
                components={{ p: <p /> }}
                values={{
                  category: category,
                  totalStockAvailable:
                    businessValues.totalStockAvailable.defaultValue,
                }}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SEOContent;
